import { render, staticRenderFns } from "./DischargeDetail.vue?vue&type=template&id=2fd86aa7"
import script from "./DischargeDetail.vue?vue&type=script&lang=js"
export * from "./DischargeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports